import { useContext } from 'react'
import { THEMES, ThemeContext } from '../contexts/ThemeContext'

const defaultThemeFallback = {
  theme: THEMES.SYSTEM,
  resolvedTheme: THEMES.LIGHT,
  isDark: false,
  setTheme: () => {},
  toggleTheme: () => {},
  themes: THEMES,
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  return context || defaultThemeFallback
}
